import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CodePanel = ({ title, content, testId, empty }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      toast.success(`${title} copied to clipboard`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className="relative rounded-xl border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-950/60 overflow-hidden" data-testid={`${testId}-panel`}>
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-zinc-200 dark:border-zinc-800">
        <span className="text-xs font-semibold uppercase tracking-[0.06em] text-zinc-500 dark:text-zinc-400">{title}</span>
        <button
          data-testid={`${testId}-copy`}
          onClick={copy}
          disabled={empty}
          className="inline-flex items-center gap-1.5 rounded-md border border-zinc-200 dark:border-zinc-700 px-2.5 py-1 text-xs font-medium text-zinc-600 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {copied ? <Check className="h-3.5 w-3.5 text-emerald-500" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="custom-scroll overflow-auto max-h-[26rem] p-4 text-[12.5px] leading-relaxed font-mono text-zinc-800 dark:text-zinc-200">
        <code data-testid={`${testId}-content`}>{empty ? "— nothing to display —" : content}</code>
      </pre>
    </div>
  );
};
